import React from 'react';
import { CFBaseRadioSVG, CFBaseToggleTokens } from '@connectrn/ds-ui-base';
import { CFRadioElements } from './Radio.styles';
export const CFRadioSVG = ({ alternateTheme = false, disabled = false, selected, }) => {
    const { Box, Radio, ViewBox } = CFBaseRadioSVG;
    const { RADIO: { BOX_FILL, BOX_STROKE, RADIO_FILL, RADIO_OPACITY }, } = CFBaseToggleTokens;
    const { SVGContainer } = CFRadioElements;
    const active = !disabled ? 'ENABLED' : 'DISABLED';
    const theme = alternateTheme ? 'ALTERNATE' : 'DEFAULT';
    const state = selected ? 'ON' : 'OFF';
    return (React.createElement(SVGContainer, null,
        React.createElement("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg' }, ViewBox),
            React.createElement("circle", Object.assign({ fill: BOX_FILL[theme][active][state], stroke: BOX_STROKE[theme][active][state] }, Box)),
            React.createElement("circle", Object.assign({ fill: RADIO_FILL[theme][active], opacity: RADIO_OPACITY[state] }, Radio)))));
};
